import React, { memo, useEffect, useState, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useLocation, useHistory } from 'react-router-dom';

import Swiper from 'react-id-swiper';
import 'swiper/css/swiper.css';

import { CONTEXT } from '../../config';
import { logging, logPostInfo } from '../../actions/log';
import WallpaperOpt from '../../components/WallpaperCard/WallpaperOpt';
import styles from './WallpaperDetail.module.less';
import { removeClass, addClass } from '../../utils/utils';
import Loading from '../../components/Loading/Loading';
import {
  getWpScreenList,
  getRecommendList,
  getAuthorShowreel,
  getDetailReco,
  getRankList,
} from '../../actions/wallpaper';
import {
  WP_DOWNLOAD_WAIT,
  WP_DOWNLOAD_ING,
  WP_DOWNLOAD_FINISHED,
  WP_PAY_DOWNLOAD_IMG,
} from '../../constants/wallpaper';

import { getQueryString, logNative, getUrlByTargetContent } from '../../utils/utils';
import transparent from '../../static/transparent.svg';
import wpAuthorDefault from '../../static/wp_author_default.png';
import { message } from 'antd';
import WpProductDownload from '../../components/WallpaperCard/WpProductDownloadBtn';
import WpTurnBtn from '../../components/WallpaperCard/WpTurnBtn';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectWpDetailList = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.wpDetailList,
);
const selectWpDetailReco = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.wpDetailReco,
);
const selectWpRankList = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.rankList,
);
const selectWpScreen = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.wpScreen,
);
const selectRecommendInfo = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.recommendInfo,
);
const selectDownloadImgs = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.wpDowloadImgs,
);

const selectWpAuthorShowreel = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.wpAuthorShowreel,
);

const selectWpPreview = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.wpPreviewInfo,
);

let WPDetailTimeoutChange = 0;
let WPDetailSliderimeout = 0;
export default memo(() => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);

  const detailList = useSelector(selectWpDetailList);
  const detailReco = useSelector(selectWpDetailReco);
  const rankList = useSelector(selectWpRankList);
  const wpScreen = useSelector(selectWpScreen);
  const recommendInfo = useSelector(selectRecommendInfo);
  const authorShowreel = useSelector(selectWpAuthorShowreel);
  // 正在任务执行中的壁纸
  const wpDowloadImgs = useSelector(selectDownloadImgs);
  // 全屏预览壁纸
  const wpPreview = useSelector(selectWpPreview);

  const midlleSwiperRef = useRef(null);
  const smallSwiperRef = useRef(null);
  const [showImg, setShowImg] = useState([]);
  const [initialSlide, setInitialSlide] = useState(null);

  const code = getQueryString('code', location.search) || '';
  const pageTage = getQueryString('pageTage', location.search) || '';
  const tagId = getQueryString('tagId', location.search) || '';
  const classId = getQueryString('classId', location.search) || '';
  const colorId = getQueryString('colorId', location.search) || '';
  const pageSource = getQueryString('pageSource', location.search) || '';
  const wallpaperId = getQueryString('wallpaperId', location.search) || '';
  const authorId = getQueryString('authorId', location.search) || '';
  const pay = getQueryString('pay', location.search) || '';

  /**
   * 统计页面浏览时长
   */
  useEffect(() => {
    const initTime = +new Date();
    return () => {
      const leaveTime = +new Date();
      dispatch(
        logging({
          category: 'I',
          action: 'View_Time',
          label: '',
          param2: {
            source: `Wallpaper_Detail`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            initTime,
            leaveTime,
            time: leaveTime - initTime,
            code,
            pageTage,
            tagId,
            classId,
            colorId,
            pageSource,
            wallpaperId,
            authorId,
          },
        }),
      );
    };
  }, []);

  useEffect(() => {
    // 更新页面 PV
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'P_Wallpaper_Detail',
        label: '',
        param2: {
          source: `Wallpaper_Detail`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          wallpaperId,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: `Wallpaper_Detail`,
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
    window.wpDetailOpenPageTime = +new Date();
    dispatch(getDetailReco({ pageType: 'wallpaperDetail' }));
  }, [dispatch]);

  useEffect(() => {
    const wallpaperId = getQueryString('wallpaperId', location.search) || '';
    if (pageSource === 'screen') {
      setShowImg([]);
      dispatch(
        getWpScreenList({ ...wpScreen.pagenation, skip: 0, limit: 48, wallpaperId, refresh: true }),
      );
    }
  }, [location]);
  /**
   * 进入详情页面，如果壁纸数量小于48且小于最大壁纸数量。重新请求数据
   * screen: 锁屏以及外部调用
   * recommendBanner: 推荐页的banner
   * recommend: 推荐页面
   * category: 分类页面
   * mine: 我的页面
   * authorDetail: 作者详情页面
   * rank: 榜单专题页面 code为专题code
   */
  useEffect(() => {
    // 如果数据为空，则重新获取数据
    if (pageSource === 'recommendBanner') {
      dispatch(
        getRecommendList({
          ...recommendInfo.pagenation,
          skip: 0,
          limit: 48,
          wallpaperId,
          refresh: true,
        }),
      );
    } else if (
      pageSource === 'recommend' &&
      (!recommendInfo.list || (recommendInfo.list && recommendInfo.list.length < 48))
    ) {
      dispatch(
        getRecommendList({ ...recommendInfo.pagenation, skip: 0, limit: 48, refresh: true }),
      );
    } else if (
      pageSource === 'authorDetail' &&
      (!authorShowreel.list ||
        (authorShowreel.list && authorShowreel.list.length < 48) ||
        (authorShowreel.pagenation && authorShowreel.pagenation.authorId !== authorId))
    ) {
      dispatch(
        getAuthorShowreel({
          ...authorShowreel.pagenation,
          authorId,
          skip: 0,
          limit: 48,
          refresh: true,
        }),
      );
    } else if (pageSource === 'rankCard') {
      dispatch(
        getRankList({
          ...rankList.pagenation,
          code,
          wallpaperId,
          pay,
          skip: 0,
          limit: 48,
          refresh: true,
        }),
      );
    } else if (
      pageSource === 'rank' &&
      (!rankList ||
        !rankList.list ||
        !rankList.code ||
        (rankList.list &&
          rankList.pagenation &&
          rankList.list.length < 48 &&
          rankList.list.length < rankList.pagenation.count) ||
        (rankList.code && rankList.code !== code))
    ) {
      dispatch(
        getRankList({
          ...rankList.pagenation,
          code,
          wallpaperId,
          pay,
          skip: 0,
          limit: 48,
          refresh: true,
        }),
      );
    }
  }, []);

  // 设置swiper数据
  useEffect(() => {
    if (pageSource === 'screen') {
      if (wpScreen.wallpapers && wpScreen.load === false && wpScreen.wallpapers.length > 0) {
        setShowImg(wpScreen.wallpapers);
      }
      if (wpScreen.status === 1 || wpScreen.status === 2) {
        // 锁屏壁纸获取失败，则展示壁纸首页
        history.push(`${CONTEXT}/wallpaper`);
      }
    } else if (pageSource === 'recommendBanner') {
      if (
        recommendInfo.list &&
        recommendInfo.load === false &&
        recommendInfo.pagenation.wallpaperId === wallpaperId &&
        (recommendInfo.list.length >= 48 ||
          (recommendInfo.pagenation.count < 48 &&
            recommendInfo.list.length === recommendInfo.pagenation.count))
      ) {
        setShowImg(recommendInfo.list);
      }
    } else if (pageSource === 'recommend') {
      if (
        recommendInfo.list &&
        recommendInfo.load === false &&
        (recommendInfo.list.length >= 48 ||
          (recommendInfo.pagenation.count < 48 &&
            recommendInfo.list.length === recommendInfo.pagenation.count))
      ) {
        setShowImg(recommendInfo.list);
      }
    } else if (pageSource === 'authorDetail') {
      if (
        authorShowreel.list &&
        authorShowreel.load === false &&
        authorShowreel.pagenation.authorId === authorId &&
        (authorShowreel.list.length >= 48 ||
          (authorShowreel.pagenation.count < 48 &&
            authorShowreel.list.length === authorShowreel.pagenation.count))
      ) {
        setShowImg(authorShowreel.list);
      }
    } else if (pageSource === 'rankCard') {
      const wallpaperId = getQueryString('wallpaperId', location.search) || '';
      if (
        rankList.list &&
        rankList.load === false &&
        rankList.code === code &&
        rankList.wallpaperId === wallpaperId &&
        (rankList.list.length >= 48 ||
          (rankList.pagenation.count < 48 && rankList.list.length === rankList.pagenation.count))
      ) {
        setShowImg(rankList.list);
      }
    } else if (pageSource === 'rank') {
      if (
        rankList.list &&
        rankList.load === false &&
        rankList.code === code &&
        (rankList.list.length >= 48 ||
          (rankList.pagenation.count < 48 && rankList.list.length === rankList.pagenation.count))
      ) {
        setShowImg(rankList.list);
      }
    } else {
      setShowImg((detailList && detailList.list) || []);
    }
  }, [wpScreen, recommendInfo, authorShowreel, rankList, detailList]);

  /**
   * 注册键盘 事件的一些特殊处理
   */
  useEffect(() => {
    if (midlleSwiperRef && smallSwiperRef && showImg?.length > 0) {
      document.addEventListener('keydown', event => {
        const ev = event || window.event;
        if (ev.code === 'KeyP' && ev.ctrlKey) {
          const midlleSwiper = midlleSwiperRef && midlleSwiperRef.current.swiper;
          if (midlleSwiper && showImg.length > 0) {
            const showImgActive = showImg[midlleSwiper.activeIndex];
            showImgActive && message.info(`当前壁纸ID: ${showImgActive.wallpaperId}`);
            logNative(
              `展示壁纸ID：${showImgActive.wallpaperId}, 顺序：${midlleSwiper.activeIndex}`,
              showImg,
              true,
              true,
            );
          }
        }
      });
    }
  }, [midlleSwiperRef, smallSwiperRef, showImg]);

  /**
   * 初始化swiper
   * 先找到初始默认展示的那一张图，initialSlide再去绘制页面
   */
  useEffect(() => {
    const wallpaperId = getQueryString('wallpaperId', location.search) || '';
    if (showImg && showImg.length > 0 && wallpaperId) {
      let initialSlide_ = 2;
      showImg.forEach((item, i) => {
        if (item.wallpaperId === wallpaperId) {
          initialSlide_ = i;
        }
      });
      setInitialSlide(initialSlide_);
      // 由于底部的swiper初始化选择某一个图不生效，所以延后让其滚动到这张图， 并且高亮
      setTimeout(() => {
        slidWallpaper(initialSlide_);
      }, 400);
      setTimeout(() => {
        slidWallpaper(initialSlide_);
      }, 1400);
    }
  }, [showImg]);

  const slidWallpaper = useCallback(
    initialSlide_ => {
      if (initialSlide_ !== null && smallSwiperRef?.current?.swiper) {
        const smallSwiper = smallSwiperRef.current.swiper;
        smallSwiper.slideTo(initialSlide_, 10, false);
        onMiddleChangeStart();
      }
    },
    [smallSwiperRef?.current],
  );

  const judgeDom = useCallback(() => {
    return (
      midlleSwiperRef &&
      midlleSwiperRef.current &&
      midlleSwiperRef.current.swiper &&
      smallSwiperRef &&
      smallSwiperRef.current &&
      smallSwiperRef.current.swiper
    );
  }, [midlleSwiperRef?.current, smallSwiperRef?.current]);

  // 当切换到壁纸，一段时间后就显示更高清的图片
  const onMiddleChangeEnd = useCallback(
    thisSwiper => {
      const activeIndex = thisSwiper.activeIndex;
      const sliderActiveDom = document.getElementById(`midlle_slider_${activeIndex}`);
      if (
        sliderActiveDom &&
        showImg[activeIndex] &&
        showImg[activeIndex].wallpaperImg &&
        showImg[activeIndex].wallpaperImg[1] &&
        showImg[activeIndex].wallpaperImg[1].uri
      ) {
        clearTimeout(WPDetailTimeoutChange);
        WPDetailTimeoutChange = setTimeout(() => {
          clearTimeout(WPDetailTimeoutChange);
          let image = new Image();
          image.src = showImg[activeIndex].wallpaperImg[1].uri;
          image.onload = () => {
            let biggerHtml = `<img
                  class="midlle_img_bigger"
                  src="${showImg[activeIndex].wallpaperImg[1].uri}"
                  alt="img"
                />`;
            if (
              showImg[activeIndex]?.supportDevice &&
              showImg[activeIndex]?.supportDevice?.indexOf('PC') === -1 &&
              showImg[activeIndex]?.supportDevice?.indexOf('PHONE') > -1
            ) {
              biggerHtml = `<img
                class="midlle_img_bigger_phone"
                src="${showImg[activeIndex].wallpaperImg[1].uri}"
                alt="img"
              />`;
            } else {
            }

            sliderActiveDom.innerHTML = biggerHtml;
          };
        }, 500);
      }
    },
    [showImg],
  );

  // 当大图切换开始，则小图改变亮度class
  const onMiddleChangeStart = useCallback(() => {
    if (judgeDom()) {
      const slider = document.getElementsByClassName('small_slider');
      const sliderActive = document.getElementsByClassName('small_slider_active');
      const midlleSwiper = midlleSwiperRef.current.swiper;
      const smallSwiper = smallSwiperRef.current.swiper;
      smallSwiper.slideTo(midlleSwiper.activeIndex);
      if (sliderActive && sliderActive.length > 0) {
        [...sliderActive].map(item => {
          removeClass(item, 'small_slider_active');
        });
      }
      if (slider.length > 0) {
        [...slider].map((item, i) => {
          if (i === midlleSwiper.activeIndex) {
            addClass(item, 'small_slider_active');
          }
        });
      }
    }
  }, [midlleSwiperRef?.current, smallSwiperRef?.current]);

  const onSmallClick = useCallback(() => {
    if (judgeDom()) {
      const midlleSwiper = midlleSwiperRef.current.swiper;
      const smallSwiper = smallSwiperRef.current.swiper;
      if (smallSwiper.clickedIndex !== undefined) {
        midlleSwiper.slideTo(smallSwiper.clickedIndex);
      }
    }
  }, [midlleSwiperRef?.current, smallSwiperRef?.current]);

  const onSmallChangeStart = useCallback(() => {
    if (judgeDom()) {
      const slider = document.getElementsByClassName('small_slider');
      const sliderActive = document.getElementsByClassName('small_slider_active');
      const midlleSwiper = midlleSwiperRef.current.swiper;
      const smallSwiper = smallSwiperRef.current.swiper;
      smallSwiper.slideTo(midlleSwiper.activeIndex);
      if (sliderActive && sliderActive.length > 0) {
        [...sliderActive].map(item => {
          removeClass(item, 'small_slider_active');
        });
      }
      if (slider.length > 0) {
        [...slider].map((item, i) => {
          if (i === midlleSwiper.activeIndex) {
            addClass(item, 'small_slider_active');
          }
        });
      }
    }
  }, [midlleSwiperRef?.current, smallSwiperRef?.current]);

  const onError = function(e) {
    if (e.currentTarget && e.currentTarget.src) {
      e.currentTarget.src = transparent;
    }
  };

  const handleAuthor = useCallback(author => {
    // 更新页面 PV
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'C_Wallpaper_AuthorMark',
        label: '',
        param2: {
          source: `Wallpaper_Detail`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          authorId: author.authorId,
          authorName: author.authorName,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source_p: logInfoData.source,
        source_pp: logInfoData.source_p,
      }),
    );
    history.push(`${CONTEXT}/wpauthordetail?authorId=${author.authorId}`);
  });

  const handleDetailRecoBanner = useCallback(() => {
    // 更新页面 PV
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'C_Wallpaper_Viewmore',
        label: '',
        param2: {
          source: `Wallpaper_Detail`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          targetType: detailReco.targetType,
          targetContent: encodeURIComponent(detailReco.targetContent),
          wallpaperId,
        },
        param3: detailReco.bizInfo,
      }),
    );
    dispatch(
      logPostInfo({
        source_p: logInfoData.source,
        source_pp: logInfoData.source_p,
      }),
    );
    if (
      detailReco.targetType === '1' ||
      detailReco.targetType === '3' ||
      detailReco.targetType === '11'
    ) {
      let url = `${CONTEXT}/wallpaper/wpcategory`;
      if (detailReco.targetType && detailReco.targetContent) {
        url = getUrlByTargetContent(detailReco);
      }
      logNative(
        `壁纸详情页面点击随便看看${detailReco.targetType} ${detailReco.targetContent} ${url}`,
        detailReco,
        true,
        true,
      );
      history.push(url);
    } else if (detailReco.targetType === '2' && detailReco.targetContent) {
      try {
        const targetContent = JSON.parse(detailReco.targetContent) || {};
        window.open(targetContent.targetUrl);
      } catch (error) {
        logNative(`壁纸详情页面点击随便看看 失败 ${JSON.stringify(detailReco)}`, {}, true, true);
      }
    } else {
      history.push(`${CONTEXT}/wallpaper/wprecommend`);
    }
  }, [detailReco]);

  const midlleParam = {
    speed: 500,
    keyboard: true,
    initialSlide: initialSlide,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      slideChangeTransitionStart(e) {
        onMiddleChangeStart();
      },
      init() {
        onMiddleChangeEnd(this);
      },
      transitionEnd() {
        onMiddleChangeEnd(this);
      },
    },
  };
  let smallParam = {
    speed: 500,
    spaceBetween: 20,
    slidesPerView: 'auto',
    initialSlide: initialSlide,
    on: {
      click(e) {
        onSmallClick();
      },
      slideChangeTransitionStart() {
        onSmallChangeStart();
      },
    },
  };
  if (showImg && showImg.length > 5) {
    smallParam = {
      ...smallParam,
      slidesPerView: 5,
      allowTouchMove: true,
      slideToClickedSlide: true,
      centeredSlides: true,
      centeredSlidesBounds: true,
    };
  }

  if (!showImg || showImg.length === 0 || initialSlide === null) {
    return (
      <div className={styles.wpdetail}>
        <Loading />
      </div>
    );
  }
  return (
    <>
      <div className={styles.wpdetail}>
        <React.Fragment>
          <div className="wpdetail_middle">
            <Swiper {...midlleParam} ref={midlleSwiperRef}>
              {showImg &&
                showImg.length > 0 &&
                showImg.map((item, i) => {
                  let wallpaperImgShow = {};
                  if (item.wallpaperImg && item.wallpaperImg[0] && item.wallpaperImg[0].uri) {
                    wallpaperImgShow = item.wallpaperImg[0];
                  } else if (
                    item.wallpaperImg &&
                    item.wallpaperImg[1] &&
                    item.wallpaperImg[1].uri
                  ) {
                    wallpaperImgShow = item.wallpaperImg[1];
                  }
                  return (
                    <div
                      className={
                        item?.supportDevice &&
                        item?.supportDevice?.indexOf('PC') === -1 &&
                        item?.supportDevice?.indexOf('PHONE') > -1
                          ? 'midlle_slider midlle_slider_pone'
                          : 'midlle_slider'
                      }
                      key={i}
                    >
                      <img
                        className={
                          item?.supportDevice &&
                          item?.supportDevice?.indexOf('PC') === -1 &&
                          item?.supportDevice?.indexOf('PHONE') > -1
                            ? 'midlle_img_phone'
                            : 'midlle_img'
                        }
                        src={wallpaperImgShow.uri || transparent}
                        onError={onError}
                        alt="img"
                      />
                      <div className={'midlle_img_bigger_box'} id={`midlle_slider_${i}`} />

                      {item.pay === 1 && <div className="wpimg_info_v"></div>}
                      <div className={`wp_mine_opt`}>
                        {item?.isShowTurn !== false && (
                          <WpTurnBtn
                            wallpaper={item}
                            cardInfo={{}}
                            logInfo={{ source: 'Wallpaper_Detail' }}
                            classType={{ type: 'wp_big', name: 'wpimg_downbtn_mid' }}
                          ></WpTurnBtn>
                        )}
                        {item?.hasDownloadButton === 1 && (
                          <div>
                            <WpProductDownload
                              wallpaper={item}
                              size="big"
                              className="wpimg_downbtn_mid"
                            ></WpProductDownload>
                          </div>
                        )}
                        <WallpaperOpt
                          wallpaper={{ ...item }}
                          cardInfo={{
                            isBig: true,
                            isCollect: true,
                            isWallpaper: true,
                            isPreview: true,
                          }}
                          logInfo={{ source: 'Wallpaper_Detail' }}
                        />
                      </div>
                      {item.author && item.author.authorName && (
                        <div className="wp_mine_author">
                          <img
                            className="wp_mine_author_header"
                            src={item.author.headPortrait || wpAuthorDefault}
                            onClick={() => handleAuthor(item.author)}
                            alt=""
                          />
                          <div
                            className="wp_mine_author_name"
                            title={item.author.authorName}
                            onClick={() => handleAuthor(item.author)}
                          >
                            {item.author.authorName}
                          </div>
                          {item.author.authorDesc && (
                            <div
                              className="wp_mine_author_desc"
                              dangerouslySetInnerHTML={{
                                __html: item.author.authorDesc.split('\n').join('<br/>'),
                              }}
                            />
                          )}
                          {item.wallpaperDesc && (
                            <div
                              className="wp_mine_author_content"
                              dangerouslySetInnerHTML={{
                                __html: item.wallpaperDesc.split('\n').join('<br/>'),
                              }}
                            />
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
            </Swiper>
          </div>
          <div className="wpdetail_small">
            <Swiper {...smallParam} ref={smallSwiperRef}>
              {showImg &&
                showImg.length > 0 &&
                showImg.map((item, i) => {
                  if (item.wallpaperImg && item.wallpaperImg[0] && item.wallpaperImg[0].uri) {
                    const found = wpDowloadImgs.find(wp => wp.wallpaperId === item.wallpaperId);
                    return (
                      <div className={'small_slider'} key={i}>
                        <img
                          className="small_img"
                          src={item.wallpaperImg[0].uri || transparent}
                          onError={onError}
                          alt="img"
                        />
                        {found &&
                          (found.status === WP_DOWNLOAD_WAIT ||
                            found.status === WP_DOWNLOAD_ING ||
                            found.status === WP_DOWNLOAD_FINISHED) && (
                            <div className="wpimg_busying">
                              <div className="wpimg_busying_progress">
                                <div
                                  className="inner"
                                  style={{
                                    width: `${found.progress}%`,
                                  }}
                                />
                              </div>
                            </div>
                          )}
                      </div>
                    );
                  }
                  return '';
                })}

              <div
                className="small_img_reco"
                onClick={() => {
                  handleDetailRecoBanner();
                }}
              >
                {detailReco &&
                  detailReco.contentImg &&
                  detailReco.targetType &&
                  detailReco.targetContent &&
                  detailReco.targetContent.indexOf('wpdetail') === -1 && (
                    <React.Fragment>
                      <div className="small_img_reco_desc">
                        {detailReco.contentDesc || '随便逛逛'}
                      </div>
                      <img className="small_img_reco_img" src={detailReco.contentImg} />
                    </React.Fragment>
                  )}
              </div>
            </Swiper>
          </div>
        </React.Fragment>
      </div>
    </>
  );
});
